import { DialogCloseEvent, DialogOpenEvent } from '@theme/dialog';
import { removeTrapFocus, trapFocus } from '@theme/focus';

const FACETS_DRAWER_SELECTOR = 'dialog-component.facets-block-wrapper';
const INITIALIZED_ATTRIBUTE = 'data-custom-focus-trap';

/**
 * Keep keyboard focus inside the facets drawer while its modal dialog is open.
 * @param {Element} facetsDrawer
 */
function initFacetsDrawerFocusTrap(facetsDrawer) {
  if (!(facetsDrawer instanceof HTMLElement)) return;
  if (facetsDrawer.hasAttribute(INITIALIZED_ATTRIBUTE)) return;

  const dialog = facetsDrawer.querySelector('dialog.facets--drawer');
  const closeButton = facetsDrawer.querySelector('.facets-drawer__close');

  if (!(dialog instanceof HTMLDialogElement)) return;

  facetsDrawer.setAttribute(INITIALIZED_ATTRIBUTE, 'true');

  facetsDrawer.addEventListener(DialogOpenEvent.eventName, () => {
    trapFocus(dialog, closeButton instanceof HTMLElement ? closeButton : null);
  });

  facetsDrawer.addEventListener(DialogCloseEvent.eventName, () => {
    removeTrapFocus();
  });
}

function initFacetsDrawers() {
  document.querySelectorAll(FACETS_DRAWER_SELECTOR).forEach(initFacetsDrawerFocusTrap);
}

initFacetsDrawers();

const observer = new MutationObserver(initFacetsDrawers);

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
